import { IAppThunk } from "../../../../app/store";
import { removeNonPublischedDevicesFromAlgosInRedux } from "../../../designSlice";
import { selectNonPublishedDevicesInSelectedTargetRoomForAdvancedCopy } from "./advancedCopyDevicesSelectors";

export const thunkRemoveCopiedDevicesFromSelectedTargetRoom = (): IAppThunk => {
  return (dispatch, getState) => {
    const devicesInTarget = selectNonPublishedDevicesInSelectedTargetRoomForAdvancedCopy(getState());

    if (devicesInTarget.length === 0) {
      return;
    }

    dispatch(
      removeNonPublischedDevicesFromAlgosInRedux(
        devicesInTarget.map((device) => String(device._id))
      )
    );
  };
};
